module.exports = __webpack_public_path__ + "img/abc-classic-2.d0afac8b.png";